export interface Upload {
  title: string;
  alt: string;
}
